import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    initialLoading: false,
    productsBase: [],
    productsAdditional: [],
    storeSubscriptionPending: false,
    storeSubscriptionCouponPending: false,
    storeAdditionalCompanyPending: false,
    cancelSubscriptionPending: false,
    changeCreditCardPending: false,
    changeSubscriptionPending: false,
    subscriptions: [],
    invoices: [],
    fetchSubscriptionPdfPending: false,
    checkCouponCodePending: false,
  },
  actions,
  mutations,
};
